import { type ClientDispatchedToolArgs } from 'api-validations/aurora'
import { isNil, isNonNil } from 'utils'

import { type MapAddress } from '../map'

// A layer id means nothing without the application it belongs to, so the pair
// is carried only when the agent named both.
const layerOf = (application: string | null | undefined, layer: string | null | undefined) =>
  isNonNil(application) && isNonNil(layer)
    ? { applicationId: application, layerId: layer }
    : undefined

export const toAnalysisFieldAddress = ({
  streamId,
  applicationId,
  layerId,
  comparison
}: ClientDispatchedToolArgs<'SetAnalysisField'>): MapAddress => ({
  kind: 'InField',
  main: { kind: 'Stream', streamId, layer: layerOf(applicationId, layerId) },
  comparison: isNil(comparison)
    ? undefined
    : {
        hidden: false,
        layer: {
          kind: 'Stream',
          streamId: comparison.streamId ?? streamId,
          layer: layerOf(comparison.applicationId, comparison.layerId)
        }
      }
})
